import history from '../../History';

// Path of the dedicated, unavoidable 2FA enrollment page (see other/RequireTwoFactorPage.jsx and
// the "enable-2fa" route in Navigation.jsx).
const TWO_FACTOR_PATH = '/enable-2fa';

// Must match SecurityRequestFilter.TWO_FACTOR_REQUIRED_HEADER / _VALUE on the backend. Every
// request that the server blocks because an administrator has mandatory 2FA pending comes back
// as a 403 carrying this header, distinguishing it from a plain "you're not logged in" 401.
const TWO_FACTOR_HEADER = 'X-Auth-Require';
const TWO_FACTOR_VALUE = 'two-factor';

let installed = false;

/**
 * Patches window.fetch once so that ANY api call made anywhere in the app -- not just the ones
 * inside route components -- gets redirected to the forced-2FA page the moment the backend says
 * it's required. This is what makes the enforcement hold even if the admin types a different URL
 * directly in the address bar or navigates through a page that doesn't itself check permissions:
 * whatever that page's first fetch call is, it will 403 and bounce them back here.
 */
export default function installTwoFactorGuard() {
  if (installed || typeof window === 'undefined' || !window.fetch) {
    return;
  }
  installed = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    try {
      if (
        response.status === 403
        && response.headers.get(TWO_FACTOR_HEADER) === TWO_FACTOR_VALUE
        && window.location.pathname !== TWO_FACTOR_PATH
      ) {
        history.push(TWO_FACTOR_PATH);
      }
    } catch {
      // Never let a guard failure break the original fetch call.
    }
    return response;
  };
}
